import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
    selector: 'emails-status-filter',
    templateUrl: './emails-status-filter.component.html',
    styleUrls: ['./emails-status-filter.component.scss']
})
export class EmailsFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('inProgressCheckbox') inProgress: ElementRef;
    @ViewChild('completedCheckbox')  completed:  ElementRef;
    @ViewChild('draftCheckbox')      draft:  ElementRef;
    @ViewChild('scheduledCheckbox')  scheduled:  ElementRef;

    constructor(
        private urlService: UrlService,
        public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const status = this.urlService.queryParams['status'];
            if (status) {
                this.inProgress.nativeElement.checked = status.indexOf('in_progress') !== -1;
                this.completed.nativeElement.checked = status.indexOf('completed') !== -1;
                this.draft.nativeElement.checked = status.indexOf('draft') !== -1;
                this.scheduled.nativeElement.checked = status.indexOf('scheduled') !== -1;
            } else {
                this.inProgress.nativeElement.checked = false;
                this.completed.nativeElement.checked = false;
                this.draft.nativeElement.checked = false;
                this.scheduled.nativeElement.checked = false;
            }
        });
    }

    changeFilter() {
        const inProgressValue = this.inProgress.nativeElement.checked;
        const completedValue  = this.completed.nativeElement.checked;
        const draftValue      = this.draft.nativeElement.checked;
        const scheduledValue  = this.scheduled.nativeElement.checked;


        if (!inProgressValue && !completedValue && !draftValue && !scheduledValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (inProgressValue) status += 'in_progress,';
            if (completedValue)  status += 'completed,';
            if (draftValue)      status += 'draft,';
            if (scheduledValue)  status += 'scheduled,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('.emails-status-filter')) this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/email-merge/emails-status-filter/emails-status-filter.component.ts